import { FC } from 'react';
import { FilterItemDetail } from '#advertList/components/filter/detail/FilterItemDetail';
import { useFilterContext } from '#advertList/components/filter/hooks/use-filter-context';

const FilterItemDetailList: FC = () => {
  const { filterItemList } = useFilterContext();

  return filterItemList.map((filterItem) => (
    <FilterItemDetail key={filterItem.link.to} filterItem={filterItem} />
  ));
};

export { FilterItemDetailList };
